"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalHeaderStyled = exports.CloseButton = void 0;

var _utils = require("../../../utils");

var _button = require("../../button");

var _const = require("../../../const");

var _icon = require("../../icon/icon.styled");

var _templateObject, _templateObject2, _templateObject3;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var modalSize = function modalSize(measure) {
  switch (measure) {
    case 'lg':
      return (0, _utils.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        display: block;\n        max-width: 500px;\n        margin: 0 auto;\n      "])));
  }

  return false;
};

var CloseButton = (0, _utils.styled)(_button.Button)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  background-color: transparent;\n  border: none;\n  position: absolute;\n  top: 0;\n  right: 0;\n  padding: 16px;\n  ", " * {\n    fill: #000;\n  }\n  &:hover,\n  &:focus {\n    ", " * {\n      fill: ", ";\n    }\n  }\n"])), _icon.IconStyled, _icon.IconStyled, _const.Colors.primary);
exports.CloseButton = CloseButton;
var ModalHeaderStyled = (0, _utils.styled)('div')(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  padding: 15px 60px;\n  text-align: center;\n  width: 100%;\n  ", ";\n  ", "\n"])), function (_ref) {
  var measure = _ref.measure;
  return modalSize(measure);
}, function (props) {
  return (0, _const.spacingStyle)(props);
});
exports.ModalHeaderStyled = ModalHeaderStyled;